import { useMemo } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import EditorPage from './pages/EditorPage';
import ExplorerPage from './pages/ExplorerPage';
import { WorkspaceProvider, useWorkspace } from './store/WorkspaceContext';

function TextLabRoutes() {
  const { settings } = useWorkspace();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: settings.theme,
          primary: {
            main: '#185abd',
          },
          secondary: {
            main: '#0f766e',
          },
          background:
            settings.theme === 'dark'
              ? { default: '#111318', paper: '#191c22' }
              : { default: '#f7f8fb', paper: '#ffffff' },
        },
        shape: {
          borderRadius: 8,
        },
        typography: {
          fontFamily:
            'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          button: {
            textTransform: 'none',
            fontWeight: 700,
          },
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none',
              },
            },
          },
          MuiButton: {
            defaultProps: {
              disableElevation: true,
            },
          },
        },
      }),
    [settings.theme]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<ExplorerPage />} />
          <Route path="/file/:fileId" element={<EditorPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <WorkspaceProvider>
      <TextLabRoutes />
    </WorkspaceProvider>
  );
}
